import React from 'react'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionActions from '@material-ui/core/AccordionActions'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers'
import Select from '@material-ui/core/Select'
import DateFnsUtils from '@date-io/date-fns'
import Slider from '@material-ui/core/Slider'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import Switch from '@material-ui/core/Switch'

const marksSlider = [
    {
        value: 1,
        label: '1 Km',
    },
    {
        value: 10,
        label: '10 Km',
    },
]

function FilterPanel(props) {
    const {
        classes,
        deviceList,
        devicesList,
        expanded,
        endDate,
        startDate,
        networkType,
        networkIndicator,
        rangeKpi,
        showConnections,
        cleanFilter,
        handleFilter,
        handleDate,
        handleStartTime,
        handleEndTime,
        valueSlider,
        handleChangeSlider,
        handleChangeAccordion,
        handleChangeDevicesList,
        handleChangeNetworkType,
        handleChangeNetworkIndicator,
        renderNetworkIndicator,
        handleSwitchConnections,
    } = props
    return (
        <div style={{ width: 300, position: 'absolute', left: 10, top: 10 }}>
            <Accordion expanded={expanded} onChange={handleChangeAccordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>KPI Filters</Typography>
                </AccordionSummary>
                <hr />
                <AccordionDetails className={classes}>
                    <InputLabel shrink id="radio-label">
                        Radio
                    </InputLabel>
                    <Slider
                        onChange={handleChangeSlider}
                        value={rangeKpi}
                        getAriaValueText={valueSlider}
                        aria-labelledby="radio-label"
                        valueLabelDisplay="auto"
                        step={1}
                        min={1}
                        max={10}
                        marks={marksSlider}
                        style={{ width: '90%', margin: '0 auto' }}
                    />
                </AccordionDetails>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <AccordionDetails className={classes}>
                        <KeyboardDatePicker
                            id="date-picker-dialog"
                            label="Select filter date"
                            format="MM/dd/yyyy"
                            value={startDate}
                            onChange={handleDate}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </AccordionDetails>
                    <AccordionDetails className={classes}>
                        <KeyboardTimePicker
                            id="start-time-picker"
                            label="Start time"
                            value={startDate}
                            onChange={handleStartTime}
                            KeyboardButtonProps={{
                                'aria-label': 'change time',
                            }}
                            keyboardIcon={<AccessTimeIcon />}
                        />
                    </AccordionDetails>
                    <AccordionDetails className={classes}>
                        <KeyboardTimePicker
                            id="end-time-picker"
                            label="End time"
                            value={endDate}
                            onChange={handleEndTime}
                            KeyboardButtonProps={{
                                'aria-label': 'change time',
                            }}
                            keyboardIcon={<AccessTimeIcon />}
                        />
                    </AccordionDetails>
                </MuiPickersUtilsProvider>
                <AccordionDetails className={classes}>
                    <InputLabel shrink id="network-type-label">
                        Devices list
                    </InputLabel>
                    <Select
                        labelId="devices-list-label"
                        value={deviceList || ''}
                        onChange={handleChangeDevicesList}
                        displayEmpty
                        className={classes.selectEmpty}
                    >
                        <MenuItem value="">
                            <em>Select device list</em>
                        </MenuItem>
                        {devicesList.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </AccordionDetails>
                <AccordionDetails className={classes}>
                    <InputLabel shrink id="network-type-label">
                        Network type
                    </InputLabel>
                    <Select
                        labelId="network-type-label"
                        value={networkType || ''}
                        onChange={handleChangeNetworkType}
                        displayEmpty
                        className={classes.selectEmpty}
                    >
                        <MenuItem value="">
                            <em>Select one</em>
                        </MenuItem>
                        <MenuItem value="LTE">LTE</MenuItem>
                        <MenuItem value="WCDMA">WCDMA</MenuItem>
                    </Select>
                </AccordionDetails>
                <AccordionDetails className={classes}>
                    <InputLabel shrink id="network-indicator-label">
                        Network indicator
                    </InputLabel>
                    <Select
                        labelId="network-indicator-label"
                        value={networkIndicator || ''}
                        onChange={handleChangeNetworkIndicator}
                        displayEmpty
                        className={classes.selectEmpty}
                    >
                        <MenuItem value="">
                            <em>Select network indicator</em>
                        </MenuItem>

                        {renderNetworkIndicator(networkType)}
                    </Select>
                </AccordionDetails>
                <AccordionDetails className={classes}>
                    <InputLabel shrink id="network-indicator-label">
                        Show connections
                    </InputLabel>
                    <Switch
                        checked={showConnections}
                        onChange={handleSwitchConnections}
                        value="checkedB"
                        color="primary"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                </AccordionDetails>
                <Divider />
                <AccordionActions>
                    <Button size="small" onClick={cleanFilter}>
                        Clean
                    </Button>
                    <Button size="small" color="primary" onClick={handleFilter}>
                        Filter
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}

export default FilterPanel
